import React, { createContext } from 'react'
import withConfig from './withConfig'

const APIRequestContext = createContext(null)

const APIRequestContextProvider = ({ config, children }) => {
    const { TOKEN } = config

    const fetchWithToken = (endpoint, options) => {
         
        return  fetch(`${endpoint}?token=${TOKEN}`, options) 
    }

    return (
        <APIRequestContext.Provider
            value={{fetchWithToken}}
        >
            {children}
        </APIRequestContext.Provider>
    )
}

export { APIRequestContext }
export default withConfig(APIRequestContextProvider)
